<template>

	<MainLayout>

		<v-container class="pa-0" appwidth>

			<v-row :class="[ this.$root.embeddedLesson ? 'ma-0' : 'mt-12' ]">

				<v-col v-if="!this.$root.embeddedLesson" cols="2" class="pa-0" />

				<v-col :cols="this.$root.embeddedLesson ? 12 : 8" class="pa-0">
					<v-card :flat="this.$root.embeddedLesson" class="pa-7">
						<h1 v-if="!this.$root.embeddedLesson" class="mb-9 text-left">
							{{ $t("message.status404") }}
						</h1>
						<h2 v-if="this.$root.embeddedLesson" class="mb-9 text-left">
							{{ $t("message.status404") }}
						</h2>
						<p class="mb-9 grey--text text--lighten-1">
							HTTP Status Code 404
						</p>
					</v-card>
				</v-col>

				<v-col v-if="!this.$root.embeddedLesson" cols="2" class="pa-0" />

			</v-row>

		</v-container>

	</MainLayout>

</template>

<script>
import MainLayout from '@/layouts/Main'

export default {
	components: {
		MainLayout
	}
}
</script>
